<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div style="min-width: 640px; max-width: 860px;">
  <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
    <h3 style="margin: 0;">Onboarding Tasks — {{ propertyCode }}</h3>
    <button pButton pRipple class="p-button-text p-button-sm" icon="pi pi-times" (click)="close()"></button>
  </div>

  <div *ngIf="!parentTask && !creating">
    <p style="color: #555;">No onboarding tasks exist for this property yet.</p>
    <button pButton pRipple class="p-button p-button-success" (click)="startOnboarding()" [disabled]="creating">
      Start Onboarding (Create 11 Tasks)
    </button>
  </div>

  <div *ngIf="creating" style="text-align: center; padding: 24px;">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4" ariaLabel="Creating tasks"></p-progressSpinner>
    <p style="margin-top: 12px; color: #555;">Creating onboarding tasks...</p>
  </div>

  <div *ngIf="parentTask && !creating">
    <div style="margin-bottom: 16px;">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px;">
        <span style="font-weight: 600;">Progress: {{ completedCount }} of {{ childTasks.length }} tasks complete</span>
        <span style="font-weight: 600; color: #2d7d46;">{{ progressPercent }}%</span>
      </div>
      <p-progressBar [value]="progressPercent" [showValue]="false" [style]="{ height: '10px' }"></p-progressBar>
    </div>

    <div *ngIf="loading" style="text-align: center; padding: 16px;">
      <p-progressSpinner [style]="{ width: '32px', height: '32px' }" strokeWidth="4" ariaLabel="Loading"></p-progressSpinner>
    </div>

    <p-table *ngIf="!loading" [value]="childTasks" styleClass="p-datatable-striped p-datatable-sm" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 36%;">Task</th>
          <th style="width: 18%;">Due Date</th>
          <th style="width: 22%;">Status</th>
          <th style="width: 24%;">Assignee</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-task>
        <tr>
          <td>{{ task.name }}</td>
          <td>{{ task.dateDue | date:'MM/dd/yyyy' }}</td>
          <td>
            <p-dropdown
              [options]="taskStatuses"
              [(ngModel)]="task.status"
              optionLabel="name"
              optionValue="value"
              appendTo="body"
              [style]="{ width: '100%' }"
              (onChange)="onStatusChange(task, task.status)">
            </p-dropdown>
          </td>
          <td>{{ task.assignedToUserVO?.fullName || task.assignedToUserVO?.firstName || '—' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" style="text-align: center; padding: 16px; color: #888;">No child tasks found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
